import gql from 'graphql-tag';
import { useCustomQuery } from '../../../../logic/api/graphQL/useCustomQuery';
import { GoogleAdsLanguageGq, GoogleAdsLanguageGqProps } from '../../models/GoogleAdsLanguageGq';

export default function useGetGoogleAdsLanguagesGq() {
  const query = useCustomQuery<ResponseGq, VariablesGq>(gqTag, {
    variables: { command: {} },
    fetchPolicy: 'cache-first',
  });

  return {
    query,
    result:
      (query?.data ?? query?.previousData)?.projects?.getGoogleAdsLanguages?.languages ??
      ([] as GoogleAdsLanguageGq[]),
  };
}

const gqTag = gql`
  query GetGoogleAdsLanguages($command: GetGoogleAdsLanguagesCommand!) {
    projects {
      getGoogleAdsLanguages(command: $command) {
        languages {
            ${GoogleAdsLanguageGqProps}
        }
      }
    }
}`;

interface VariablesGq {
  command: GetGoogleAdsLanguagesCommand;
}

export interface GetGoogleAdsLanguagesCommand {}

interface ResponseGq {
  projects: {
    getGoogleAdsLanguages: {
      languages: GoogleAdsLanguageGq[];
    };
  };
}
